
import ActionTypes from "./ActionTypes";
import InteractionTypes from "./InteractionTypes";

const InsideThisBookEventTypes = {
    SAMPLEPAGES_VIEW_CLICKED: { 
        featureClick: { 
            name: "ContentCafeExcerpt"
        },
		interaction: {
			name: 'Inside This Book: Sample Pages - clicked',
			actionType: ActionTypes.INLINE_DISPLAY,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: 'Sample Pages'
		}
    },
	FLAPCOVER_VIEW_CLICKED: { 
        featureClick: { 
            name: "ContentCafeFlap" 
        },
		interaction: {
			name: 'Inside This Book: Flap Cover - clicked',
			actionType: ActionTypes.INLINE_DISPLAY,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: 'Cover Flap'
		}
    },
	TOC_VIEW_CLICKED: { 
        featureClick: { 
            name: "ContentCafeToc" 
        },
		interaction: {
			name: 'Inside This Book: TOC - clicked',
			actionType: ActionTypes.INLINE_DISPLAY,
			interactionType: InteractionTypes.CALL_TO_ACTION,
			featureType: 'Table of Contents'
		}
    },
}


export default InsideThisBookEventTypes;



// WEBPACK FOOTER //
// ./src/data/types/InsideThisBookEventTypes.js